import { render } from "./ippsu.vue?vue&type=template&id=085321b6&scoped=true"
import script from "./ippsu.vue?vue&type=script&lang=js"
export * from "./ippsu.vue?vue&type=script&lang=js"

import "./ippsu.vue?vue&type=style&index=0&id=085321b6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-085321b6"

export default script